import type { Menu, NestedMenuItem } from "types/menu"
import { universalMenuItems } from "./universal"

/**
 * deepest apologies to the next developer
 *
 * because this code is SHIT
 *
 * please delete it and reimplement
 *
 * preferably with routes and menu handled from one place only
 *
 * ...and while you're at it delete this site and rebuild with REMIX
 */

export const getSIPMenu = ({
  actionLogging = false,
  weather = false,
  adhesion = false,
  srr = false,
  tickSheets = false,
  internal = false,
} = {}): Menu => {
  let treatmentItemsSIP = baseItemsSIP

  if (actionLogging) {
    treatmentItemsSIP = [...treatmentItemsSIP, actionLoggingItem]
  } else {
    treatmentItemsSIP = treatmentItemsSIP.filter((item) => item.label !== actionLoggingItem.label)
  }

  if (srr) {
    treatmentItemsSIP = [...treatmentItemsSIP, srrItem]
  } else {
    treatmentItemsSIP = treatmentItemsSIP.filter((item) => item.label !== srrItem.label)
  }

  if (tickSheets) {
    treatmentItemsSIP = [...treatmentItemsSIP, tickSheetsItem, siteReviewItem]
  } else {
    treatmentItemsSIP = treatmentItemsSIP.filter((item) => item.label !== tickSheetsItem.label && item.label !== siteReviewItem.label)
  }

  if (weather) {
    treatmentItemsSIP = [...treatmentItemsSIP, weatherItem]
  } else {
    treatmentItemsSIP = treatmentItemsSIP.filter((item) => item.label !== weatherItem.label)
  }

  let adhesionItemsSIP: NestedMenuItem[] = []

  if (adhesion) {
    adhesionItemsSIP = [...adhesionItemsSIP, adhesionItem]
  } else {
    adhesionItemsSIP = adhesionItemsSIP.filter((item) => item.label !== adhesionItem.label)
  }

  let menu: Menu = [
    {
      label: "Treatment",
      items: treatmentItemsSIP,
    },
  ]

  if (adhesionItemsSIP.length > 0) {
    menu = [
      ...menu,
      { separator: true },
      {
        label: "Adhesion Reporting",
        items: adhesionItemsSIP,
      },
      { separator: true },
      ...universalMenuItems({}),
    ]
  } else {
    menu = [...menu, { separator: true }, ...universalMenuItems({})]
  }

  // Super-admins: Customer Configuration (NR control-desk visibility, ART-3177)
  if (internal) {
    menu = [
      ...menu,
      { separator: true },
      { label: "Internal", items: [{ label: "Customer Configuration", icon: "pi pi-fw pi-building", to: "/customers" }] },
    ]
  }

  return menu
}

const baseItemsSIP = [
  {
    label: "Overview",
    icon: "pi pi-fw pi-wifi",
    to: "/",
  },
  {
    label: "Treatment Analysis",
    icon: "pi pi-fw pi-map-marker",
    to: "/treatment-analysis",
  },
]

const actionLoggingItem = {
  label: "Action Logging",
  icon: "pi pi-check-circle",
  to: "/action-logging",
}

const weatherItem = {
  label: "Weather",
  icon: "pi pi-fw pi-sun",
  to: "/weather",
}

const adhesionItem = {
  label: "Adhesion Analysis",
  icon: "pi pi-fw  pi-chart-line",
  to: "/adhesion-analysis",
  disabled: false,
}

const srrItem = {
  label: "Sites Requiring Review",
  icon: "pi pi-fw pi-exclamation-triangle",
  to: "/srr",
}

const tickSheetsItem = {
  label: "NROL Circuit Review",
  icon: "pi pi-fw pi-check-square",
  to: "/nrol",
}

const siteReviewItem = {
  label: "NROL Site Review",
  icon: "pi pi-fw pi-globe",
  to: "/network-view",
}

// const otherSIPItems = [
//   {
//     label: "Seasonal Analysis",
//     icon: "pi pi-fw pi-calendar",
//     to: "/seasonalanalysis",
//     disabled: true,
//   },
//   {
//     label: "[PREVIEW] Lost Time",
//     icon: "pi pi-fw pi-clock",
//     to: "/losttime",
//     disabled: true,
//   },
// ]
